import { Filmomtale } from "@filmweb/sanity-types";
import ArticleItem from "components/frontpage/otherarticles/ArticleItem";
import { DocumentType_MOVIE, IMovieArticle, INewsArticle, ISpecialShowArticle } from "lib/types/sanity";
import styles from "./OtherArticles.module.css";

//#region [Props]
type OtherArticlesProps = {
    articleList?: (ISpecialShowArticle | INewsArticle | IMovieArticle)[];
    fwFilms?: Filmomtale[];
    allowTitleOverride?: boolean;
};
//#endregion

//#region [Component]
export default function OtherArticles({ articleList, fwFilms, allowTitleOverride = false }: OtherArticlesProps) {
    if ((articleList?.length ?? 0) === 0) {
        return null;
    }

    const artList = articleList?.filter(art => !!art?._id);

    return <section className={styles.SOtherArtsContainer}>
        {artList!.map(article => {
            let movie: Filmomtale | undefined;
            if (article._type === DocumentType_MOVIE) {
                const edi = (article as IMovieArticle).edi.current;
                movie = fwFilms?.find(film => film.mainVersionEDI === edi);
            }
            return <ArticleItem key={article._id} article={article} film={movie} allowTitleOverride={allowTitleOverride} />;
        })}
    </section>
}
//#endregion